import { MatchStatuses } from '../audit-result/MatchStatuses';
import { VerifyMatchTarget } from './verify-match-types';
import { VerifyMatchMentionStatus } from './VerifyMatchMentionStatus';

export interface VerifyMatchStatusProps {
  target: VerifyMatchTarget;
}

/**
 * Status indicators for the current verify-match target (spot or mention).
 */
export function VerifyMatchStatus({ target }: VerifyMatchStatusProps) {
  if (target.kind === 'spot') {
    return <MatchStatuses match={target.match} />;
  }

  return <VerifyMatchMentionStatus mention={target.mention} />;
}
